/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ProducedMaterialType {
  None = 'None',
  ProducedMaterial = 'ProducedMaterial',
  OutputUnit = 'OutputUnit'
}
